import { SET_HIGHLIGHT_LINKS, CLEAR_HIGHLIGHT_LINKS } from 'actions'

const initialState = {
  highlightLinks: {}
}

export default (state = initialState, { type, payload }) => {
  if (type === SET_HIGHLIGHT_LINKS) {
    return {
      ...state,
      highlightLinks: {
        ...payload
      }
    }
  } else if (type === CLEAR_HIGHLIGHT_LINKS) {
    return {
      ...state,
      highlightLinks: {}
    }
  }

  return state
}
